import { createIntl, createIntlCache } from 'react-intl';
import { queryClient } from 'Core/queryClient';
import { NotificationManager } from 'Components/Notifications';
import { isActiveStatus } from './constants';
import { cachedCopies, updateCommand } from './remoteCommandsCache';
import { commandLabel, statusLabel } from './remoteCommandsUtils';
import en from './lan/en';
import es from './lan/es';

const MESSAGES = { en, es };
const intlCache = createIntlCache();

/** Outside React: same language source as NotificationManager (`localStorage.lan`). */
const currentIntl = () => {
	const locale = localStorage.getItem('lan') || 'en';
	return createIntl({ locale, messages: MESSAGES[locale] || en }, intlCache);
};

/** Whether this browser had the command cached as still active (i.e. it is waiting for it). */
const wasCachedActive = (client, row) => cachedCopies(client, row).some((item) => isActiveStatus(item.status));

const toastFinalStatus = (row) => {
	const intl = currentIntl();
	const command = commandLabel(row.command, intl.messages);
	if (row.status === 'SUCCEEDED') {
		NotificationManager.success(intl.formatMessage({ id: 'oemDataModal_remote_succeededToast' }, { command }));
		return;
	}
	const status = row.errorMessage || statusLabel(row.status, intl.messages);
	NotificationManager.error(intl.formatMessage({ id: 'oemDataModal_remote_failedToast' }, { command, status }));
};

/**
 * A newer version of a command (WebSocket notification or status check):
 * replaces the row in the unit's cached current command and history (if
 * cached) and the single-command cache, and toasts once when this browser was
 * waiting for it (cached as active) and it is now final.
 */
export const applyRemoteCommandUpdate = (row, client = queryClient) => {
	if (!row?.id || row.unitId === undefined || row.unitId === null) return;

	const notify = wasCachedActive(client, row) && !isActiveStatus(row.status);
	updateCommand(client, row);
	if (notify) toastFinalStatus(row);
};

/**
 * WebSocket `Notification` with `payload = { type: 'VehicleRemoteCommand', data }`
 * (final status, sent to every socket of the account).
 */
export const handleVehicleRemoteCommandNotification = (payload, client = queryClient) =>
	applyRemoteCommandUpdate(payload?.data, client);
